/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionMatchDispute } from './CompetitionMatchDispute';
import {
    CompetitionMatchDisputeFromJSON,
    CompetitionMatchDisputeFromJSONTyped,
    CompetitionMatchDisputeToJSON,
    CompetitionMatchDisputeToJSONTyped,
} from './CompetitionMatchDispute';
import type { CompetitionSeriesGame } from './CompetitionSeriesGame';
import {
    CompetitionSeriesGameFromJSON,
    CompetitionSeriesGameFromJSONTyped,
    CompetitionSeriesGameToJSON,
    CompetitionSeriesGameToJSONTyped,
} from './CompetitionSeriesGame';
import type { CompetitionMatchParticipant } from './CompetitionMatchParticipant';
import {
    CompetitionMatchParticipantFromJSON,
    CompetitionMatchParticipantFromJSONTyped,
    CompetitionMatchParticipantToJSON,
    CompetitionMatchParticipantToJSONTyped,
} from './CompetitionMatchParticipant';
import type { MatchScoringMode } from './MatchScoringMode';
import {
    MatchScoringModeFromJSON,
    MatchScoringModeFromJSONTyped,
    MatchScoringModeToJSON,
    MatchScoringModeToJSONTyped,
} from './MatchScoringMode';
import type { MatchReadinessResponse } from './MatchReadinessResponse';
import {
    MatchReadinessResponseFromJSON,
    MatchReadinessResponseFromJSONTyped,
    MatchReadinessResponseToJSON,
    MatchReadinessResponseToJSONTyped,
} from './MatchReadinessResponse';
import type { CompetitionScoreSubmission } from './CompetitionScoreSubmission';
import {
    CompetitionScoreSubmissionFromJSON,
    CompetitionScoreSubmissionFromJSONTyped,
    CompetitionScoreSubmissionToJSON,
    CompetitionScoreSubmissionToJSONTyped,
} from './CompetitionScoreSubmission';
import type { CompetitionType } from './CompetitionType';
import {
    CompetitionTypeFromJSON,
    CompetitionTypeFromJSONTyped,
    CompetitionTypeToJSON,
    CompetitionTypeToJSONTyped,
} from './CompetitionType';
import type { MatchFormat } from './MatchFormat';
import {
    MatchFormatFromJSON,
    MatchFormatFromJSONTyped,
    MatchFormatToJSON,
    MatchFormatToJSONTyped,
} from './MatchFormat';
import type { CompetitionOverwolfVerification } from './CompetitionOverwolfVerification';
import {
    CompetitionOverwolfVerificationFromJSON,
    CompetitionOverwolfVerificationFromJSONTyped,
    CompetitionOverwolfVerificationToJSON,
    CompetitionOverwolfVerificationToJSONTyped,
} from './CompetitionOverwolfVerification';
import type { CompetitionMatchStatus } from './CompetitionMatchStatus';
import {
    CompetitionMatchStatusFromJSON,
    CompetitionMatchStatusFromJSONTyped,
    CompetitionMatchStatusToJSON,
    CompetitionMatchStatusToJSONTyped,
} from './CompetitionMatchStatus';

/**
 * Universal match record response, used across all competition types
 * @export
 * @interface MatchResponse
 */
export interface MatchResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchResponse
     */
    id: string;
    /**
     * 
     * @type {CompetitionType}
     * @memberof MatchResponse
     */
    competitionType: CompetitionType;
    /**
     * 
     * @type {string}
     * @memberof MatchResponse
     */
    competitionId: string;
    /**
     * 
     * @type {CompetitionMatchStatus}
     * @memberof MatchResponse
     */
    status: CompetitionMatchStatus;
    /**
     * 
     * @type {MatchScoringMode}
     * @memberof MatchResponse
     */
    scoringMode: MatchScoringMode;
    /**
     * 
     * @type {MatchFormat}
     * @memberof MatchResponse
     */
    format: MatchFormat;
    /**
     * 
     * @type {CompetitionMatchParticipant}
     * @memberof MatchResponse
     */
    participant1?: CompetitionMatchParticipant;
    /**
     * 
     * @type {CompetitionMatchParticipant}
     * @memberof MatchResponse
     */
    participant2?: CompetitionMatchParticipant;
    /**
     * 
     * @type {string}
     * @memberof MatchResponse
     */
    winnerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatchResponse
     */
    isDraw: boolean;
    /**
     * 
     * @type {Array<CompetitionScoreSubmission>}
     * @memberof MatchResponse
     */
    submissions: Array<CompetitionScoreSubmission>;
    /**
     * 
     * @type {CompetitionMatchDispute}
     * @memberof MatchResponse
     */
    dispute?: CompetitionMatchDispute;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    scheduledTime?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    startedAt?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    completedAt?: number;
    /**
     * Timed-window scoring cutoff (epoch ms) — present only on TIME_BASED matches once IN_PROGRESS; events after it are not scored
     * @type {number}
     * @memberof MatchResponse
     */
    scoringEndsAt?: number;
    /**
     * 
     * @type {CompetitionOverwolfVerification}
     * @memberof MatchResponse
     */
    overwolfVerification?: CompetitionOverwolfVerification;
    /**
     * 
     * @type {MatchReadinessResponse}
     * @memberof MatchResponse
     */
    readiness?: MatchReadinessResponse;
    /**
     * 
     * @type {Array<CompetitionSeriesGame>}
     * @memberof MatchResponse
     */
    seriesGames: Array<CompetitionSeriesGame>;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    roundNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    matchIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchResponse
     */
    bracketMatchId?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof MatchResponse
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the MatchResponse interface.
 */
export function instanceOfMatchResponse(value: object): value is MatchResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('competitionType' in value) || value['competitionType'] === undefined) return false;
    if (!('competitionId' in value) || value['competitionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('scoringMode' in value) || value['scoringMode'] === undefined) return false;
    if (!('format' in value) || value['format'] === undefined) return false;
    if (!('isDraw' in value) || value['isDraw'] === undefined) return false;
    if (!('submissions' in value) || value['submissions'] === undefined) return false;
    if (!('seriesGames' in value) || value['seriesGames'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MatchResponseFromJSON(json: any): MatchResponse {
    return MatchResponseFromJSONTyped(json, false);
}

export function MatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'competitionType': CompetitionTypeFromJSON(json['competitionType']),
        'competitionId': json['competitionId'],
        'status': CompetitionMatchStatusFromJSON(json['status']),
        'scoringMode': MatchScoringModeFromJSON(json['scoringMode']),
        'format': MatchFormatFromJSON(json['format']),
        'participant1': json['participant1'] == null ? undefined : CompetitionMatchParticipantFromJSON(json['participant1']),
        'participant2': json['participant2'] == null ? undefined : CompetitionMatchParticipantFromJSON(json['participant2']),
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'isDraw': json['isDraw'],
        'submissions': ((json['submissions'] as Array<any>).map(CompetitionScoreSubmissionFromJSON)),
        'dispute': json['dispute'] == null ? undefined : CompetitionMatchDisputeFromJSON(json['dispute']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'completedAt': json['completedAt'] == null ? undefined : json['completedAt'],
        'scoringEndsAt': json['scoringEndsAt'] == null ? undefined : json['scoringEndsAt'],
        'overwolfVerification': json['overwolfVerification'] == null ? undefined : CompetitionOverwolfVerificationFromJSON(json['overwolfVerification']),
        'readiness': json['readiness'] == null ? undefined : MatchReadinessResponseFromJSON(json['readiness']),
        'seriesGames': ((json['seriesGames'] as Array<any>).map(CompetitionSeriesGameFromJSON)),
        'roundNumber': json['roundNumber'] == null ? undefined : json['roundNumber'],
        'matchIndex': json['matchIndex'] == null ? undefined : json['matchIndex'],
        'bracketMatchId': json['bracketMatchId'] == null ? undefined : json['bracketMatchId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function MatchResponseToJSON(json: any): MatchResponse {
    return MatchResponseToJSONTyped(json, false);
}

export function MatchResponseToJSONTyped(value?: MatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'competitionType': CompetitionTypeToJSON(value['competitionType']),
        'competitionId': value['competitionId'],
        'status': CompetitionMatchStatusToJSON(value['status']),
        'scoringMode': MatchScoringModeToJSON(value['scoringMode']),
        'format': MatchFormatToJSON(value['format']),
        'participant1': CompetitionMatchParticipantToJSON(value['participant1']),
        'participant2': CompetitionMatchParticipantToJSON(value['participant2']),
        'winnerId': value['winnerId'],
        'isDraw': value['isDraw'],
        'submissions': ((value['submissions'] as Array<any>).map(CompetitionScoreSubmissionToJSON)),
        'dispute': CompetitionMatchDisputeToJSON(value['dispute']),
        'scheduledTime': value['scheduledTime'],
        'startedAt': value['startedAt'],
        'completedAt': value['completedAt'],
        'scoringEndsAt': value['scoringEndsAt'],
        'overwolfVerification': CompetitionOverwolfVerificationToJSON(value['overwolfVerification']),
        'readiness': MatchReadinessResponseToJSON(value['readiness']),
        'seriesGames': ((value['seriesGames'] as Array<any>).map(CompetitionSeriesGameToJSON)),
        'roundNumber': value['roundNumber'],
        'matchIndex': value['matchIndex'],
        'bracketMatchId': value['bracketMatchId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

